<template lang="">
  <div>
    <div class="userinfoForm" v-loading="loading">
      <el-form ref="userinfoForm" :model="userinfoForm" label-width="80px" size="small">
        <el-form-item label="头像" class="" prop="filephoto" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-upload class="avatar-uploader userpicture" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :show-file-list="false" :http-request="changeImageUpload" :before-upload="handleBeforeUpload" placeholder="头像" title="头像">
            <el-image v-if="userinfoForm.filephoto" class="avatar" :src="imgBase+userinfoForm.filephoto" fit="cover"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="name" :rules="{ required: true, message: '必填', trigger: 'blur' }">
          <el-input type="text" v-model="userinfoForm.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" :rules="{ required: true, message: '必填', trigger: 'change' }">
            <el-radio-group v-model="userinfoForm.gender" size="small">
                <el-radio-button label="1">男</el-radio-button>
                <el-radio-button label="2">女</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="职位" prop="position" :rules="{ required: true, message: '必填', trigger: 'blur' }">
          <el-input type="text" v-model="userinfoForm.position" placeholder="职位"></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="department" :rules="{ required: true, message: '必填', trigger: 'blur' }">
          <el-input type="text" v-model="userinfoForm.department" placeholder="部门"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="mobile">
          <el-input type="text" v-model="userinfoForm.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('userinfoForm')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import * as API from '@/api/main'
export default {
  data(){
    return {
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      loading:false,
      userinfoForm:{
        filephoto:"",
      },
    }
  },
  methods: {

    // 上传文件之前的钩子
    handleBeforeUpload(file){
      if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          this.$message({
              type: 'warning',
              message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
          });
          return false;
      }
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      if(size > 1) {
          this.$message({
              type: 'warning',
              message: '图片大小必须小于1M'
          });
          return false;
      }
    },

    //图片上传
    changeImageUpload(options) {
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
          API.ImgUpload({filephoto:base64Str}).then(res => {
            this.userinfoForm.filephoto=res.data.filepath;
          })
      }
      // fileReader.onload = () => {
      //   let base64Str = fileReader.result
      //   this.regInfo.picture=base64Str;
      // }
    },

    //获取登陆者信息
    getUserInfo(){
      this.loading=true;
      API.GetUserInfo().then(res=>{
        this.userinfoForm=res.data;
        this.loading=false;
      })
    },

    //提交
    submitForm(formName){
      let userInfo=JSON.parse(localStorage.getItem("user"))
      this.$refs[formName].validate((valid) => {
        if (valid) {          
            API.UpdateUserInfo(this.userinfoForm).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });     
              this.userinfoForm=res.data;
              userInfo.name=res.data.name;
              userInfo.gender=res.data.gender;
              userInfo.position=res.data.position;
              userInfo.department=res.data.department;
              userInfo.filephoto=res.data.filephoto;
              localStorage.removeItem('user');
              localStorage.setItem('user',JSON.stringify(userInfo));
              location.reload();
            })
        } else {
          return false;
        }
      });
    },


  },
  created() {
    
    this.getUserInfo();
  },
}
</script>
<style scoped>
  .userinfoForm{width:500px;margin-left:50px;}
  .userinfoForm .el-form-item__label{width:130px;}
  .avatar-uploader-icon{font-size: 28px; color: #8c939d; width: 100px;height: 100px; line-height: 100px;text-align: center;}    
  .el-image{height:100px;width:100px;border-radius: 50%;}
  .el-image img{height:100%;}
  @media screen and (max-width: 1200px) {
    .userinfoForm{width:100%;margin-left:0;}
    .el-image{}
  }
</style>